import * as moment from 'moment';
export class CreditScoreFactors {
        id: number;
        creditScoreID: string;
        borrowerID: string;
        creditFileID: string;
        creditReportIdentifier: string;
        creditRepositorySourceType: CreditRepositories | null;
        fACTAInquiriesIndicator: string;
        modelNameType: string;
        value: string;
        creditResponseId: number;
        token: string;
        text: string;
        orderDate: Date;
    }


    export enum CreditRepositories {
        Equifax = 0,
        Experian = 1,
        Transunion = 2
    } 

    export enum CreditScoreTypes {
        FICO = 0,
        VANTAGE = 1,
    } 

    export class SimpleCreditRepo
    {
        name : string;
        id : number;
    }

    export class CreditReportApplicantInfo {
        alertMessage: string;
        fullName: string;
        ssn: string;
        dob: Date | null;
        referenceId: string;
        orderDate: Date | string;
        screeningDOB: Date | null;
        screeningSSN: string;
        screeningFullName: string;
        totalDebt: number;

        public get ssnMatch(): boolean {

            if (this.ssn == null) {
                return false;
            }

            const m1 = this.ssn.replace(/-|\s/g, '');
            const m2 = this.screeningSSN.replace(/-|\s/g, '');

            return m1 === m2;
        }

        public get dobMatch(): boolean {
            if (this.dob != null) {
                const sdob = new Date(this.screeningDOB);
                const cdob = new Date(this.dob);
                if (sdob.getDay() == cdob.getDay()
                && sdob.getMonth() == cdob.getMonth()
                && sdob.getFullYear() == cdob.getFullYear()) {
              return true;
                }
            }

            return false;
        }

        public get nameMatch(): boolean {
            // need to look at the name parts and make sure we have a 2/3 match
            if (this.screeningFullName == null || this.fullName == null) {
                return false;
            }

            const snameParts = this.screeningFullName.split(' ');
            const rnameParts = this.fullName.split(' ');

            const denominator = snameParts.length > rnameParts.length ? snameParts.length : rnameParts.length;

             // Get the number of matches between the 2 lists.
            let count = 0;
            snameParts.forEach(n1 => {
                rnameParts.forEach(n2 => {
                    if (n2.toLowerCase() === n1.toLowerCase()) {
                        count++;
                    }
                });
            });

            return (count / denominator) >= .66;
        }
    }


    export class CreditReportAddress {
        referenceId: string;
        orderDate: Date | string;
        zipCode: string;
        state: string;
        city: string;
        street: string;
        currentAddress: boolean;
        screeningState: string;
        screeningStreet: string;
        screeningCity: string;
        screeningZip: string;
        public get isAddressMatch(): boolean {
            return this.state == this.screeningState && this.city == this.screeningCity && this.zipCode == this.screeningZip;
        }
    }

    export class CreditReportEmployer {
        referenceId: string;
        orderDate: Date | string;
        id: number;
        borrowerId: number;
        name: string;
        position: string;
        reportedDate: Date | null;
    }

    export class CreditReportTradeLine {
        referenceId: string;
        orderDate: Date | string;
        accountOwnershipType: string;
        accountStatusType: string;
        accountType: string;
        accountOpenedDate: string;
        accountReportedDate: string;
        accountClosedDate: string;
        paymentPattern: string;
        paymentStartDate: string;
        currentRatingCode: string;
        currentRatingType: string;
        creditor: string;
        monthlyPaymentAmount: number | null;
        monthsReviewedCount: number | null;
        lastActivityDate: Date | string | null;
        pastDueAmount: number | null;
        unpaidBalanceAmount: number | null;
        comments: CreditComment[];

        paymentHistory: PaymentHistory[] = [];

        // run down the payment pattern starting with the payment start date and build out all the history entries. 
        // Then in the ui just show the last 12.
        buildPaymentHistory() {

            const mt = this.paymentStartDate ? moment(this.paymentStartDate) : null;

            if (this.paymentPattern && this.paymentPattern != null) {
                const arrlength = this.paymentPattern.length >= 12 ? this.paymentPattern.length : 12;

                for (let i = 0; i < arrlength; i++) {

                    const ph = new PaymentHistory();
                    ph.paymentStartDate = mt;
                    ph.mo = this.paymentPattern[i] ? mt.month() : null;
                    ph.moStr = this.paymentPattern[i] ? mt.format('MMM') : '';
                    
                    ph.yrStr = this.paymentPattern[i] ? mt.format('YY') : '';
                    ph.ratingCode = this.paymentPattern[i];
                    this.paymentHistory.push(ph);
                
                    mt.subtract(1, 'month');
                }

                // Just keep the last 12
                this.paymentHistory = this.paymentHistory.length > 12
                    ? this.paymentHistory.slice(0, 12) : this.paymentHistory;
            }

        }
    }

    export class PaymentHistory {
        moStr: string;
        mo: number;
        ratingCode: string;

        public get pastDue(): boolean {
            return this.ratingCode != '1' && this.ratingCode != 'C';
        }

        yrStr: string;
        paymentStartDate: moment.Moment;
    }

    export class CreditComment {
        id: number;
        text: string;
        sourceType: string;
        type: string;
        code: string;
        creditLiabilityId: number;
    }


    export class CreditReportInquiry {
        referenceId: string;
        orderDate: Date | string;
        name: string;
        date: string;
    }

    export class CreditPublicRecordBag {
        referenceId: string;
        orderDate: Date | string;
        dispositionDate: string;
        dispositionType: string;
        docketIdentifier: string;
        fileDate: string;
        amount: string;
        type: string;
        plaintiff: string;
        courtName: string;
        bKAssetAmount: string;
        bKLiabilityAmount: string;
        creditResponseId: number;
        id: number;

    }





